// @flow strict
import { Button, Card, Descriptions, message } from 'antd';
import { useState } from 'react';
import { redeemReferRule } from '../../../api/refer';

function RuleCard({ rule, point, userInfo }) {
  const [loading, setLoading] = useState(false);

  const handleRedeemPoint = async () => {
    setLoading(true);

    try {
      const payload = {
        companyId: userInfo?.companyId,
        ruleId: rule?._id,
      };
      const res = await redeemReferRule(payload);

      if (res?.data?.status === "success") {
        message.success(res.data.message);
        window.location.reload();
      };
    } catch (error) {
      message.error(error?.message);
    } finally {
      setLoading(false);
    };
  };

  return (
    <Card
      title={
        <div className="d-flex justify-content-between align-items-center">
          <span>Points : {point}</span>
          <Button
            disabled={point < rule?.points}
            onClick={handleRedeemPoint}
            loading={loading}
            type="primary">
            Collect Now
          </Button>
        </div>
      }
    >
      <Descriptions column={2}>
        <Descriptions.Item label="Points">
          {rule?.points}
        </Descriptions.Item>
        <Descriptions.Item label="Chat Token">
          {rule?.token}
        </Descriptions.Item>
        <Descriptions.Item label="Day Extend">
          {rule?.days || 0}
        </Descriptions.Item>
        <Descriptions.Item label="Assistant Limit">
          {rule?.assistant || 0}
        </Descriptions.Item>
        <Descriptions.Item className="text-capitalize" label="Chat Providers">
          {rule?.chat_providers?.length > 0 ? rule?.chat_providers?.join(', ') : '[ ]'}
        </Descriptions.Item>
        <Descriptions.Item label="Max File Upload">
          {rule?.max_file || 0}
        </Descriptions.Item>
        <Descriptions.Item label="User Limit">
          {rule?.user || 0}
        </Descriptions.Item>
        <Descriptions.Item label="Advance Parameter">
          {rule?.advance_parameter ? "Yes" : "No"}
        </Descriptions.Item>
        <Descriptions.Item label="Customize Chat">
          {rule?.customize_chat ? "Yes" : "No"}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default RuleCard;